import React, { useMemo } from 'react';

import _ from 'lodash';
import { Flex } from 'antd';
import { ResponsivePie } from '@nivo/pie';
import useOccurrences from 'src/pages/dashboard/contexts/useOccurrences';
import { WidgetSubtitle, WidgetTitle } from 'src/pages/dashboard/styles';

export default function OccurrencesBySeverity() {

	const { occurrences, } = useOccurrences();

	const data = useMemo(() => {
		const alertOccurrences = occurrences.filter(occ => !occ.is_recovery);
		const groupedBySeverity = _.groupBy(alertOccurrences, (occurrence) =>
			occurrence.observer.severity.name
		);

		return _.map(groupedBySeverity, (value, key) => ({
			id: key,
			label: key,
			value: value.length,
			color: value[0].observer.severity.color,
		}));
	}, [ occurrences, ]);

	const severityWithMostOccurrence = useMemo(() => {
		const totalOccurrences = _.sumBy(data, 'value');
		const severityWithMostOccurrences = _.maxBy(data, 'value');

		if(!severityWithMostOccurrences) {
			return {
				name: '',
				count: 0,
			};
		}

		const percentageOfMostOccurrences = (severityWithMostOccurrences.value / totalOccurrences) * 100;

		return {
			name: severityWithMostOccurrences.label,
			count: percentageOfMostOccurrences,
		};
	}, [ data, ]);

	return (
		<Flex vertical justify='space-between' style={{ height: '100%', }}>
			<div style={{ height: '260px', }}>
				<ResponsivePie
					data={data}
					margin={{ top: 10, right: 20, bottom: 60, left: 20, }}
					sortByValue={true}
					innerRadius={0.5}
					padAngle={1}
					cornerRadius={6}
					activeOuterRadiusOffset={8}
					colors={(data) => data.data.color}
					enableArcLinkLabels={false}
					legends={[
						{
							anchor: 'bottom',
							direction: 'row',
							justify: false,
							translateX: 0,
							translateY: 30,
							itemsSpacing: 0,
							itemWidth: 100,
							itemHeight: 18,
							itemTextColor: '#999',
							itemDirection: 'left-to-right',
							itemOpacity: 1,
							symbolSize: 18,
							symbolShape: 'circle',
							effects: [
								{
									on: 'hover',
									style: {
										itemTextColor: '#000',
									},
								},
							],
						},
					]}
				/>
			</div>
			<Flex gap={8} vertical>
				<WidgetTitle>
                    Ocorrências por severidade
				</WidgetTitle>
				<WidgetSubtitle>
                    A severidade {severityWithMostOccurrence.name} representa{' '}
					{severityWithMostOccurrence.count?.toFixed(2)}% do total de ocorrências.
				</WidgetSubtitle>
			</Flex>
		</Flex>
	);
}
